<template>
  <div>
    <label v-if="label">{{ label }}</label>
    <template v-if="name">
      <template v-if="type === 'text'">
        <q-input
          :for="`text-input-${name}`"
          v-model="values[name]"
          :maxlength="maxLength"
          :readonly="readonly"
        ></q-input>
      </template>
      <template v-if="type === 'numeric'">
        <q-input
          :for="`numeric-input-${name}`"
          v-model="values[name]"
          :maxlength="maxLength"
          :readonly="readonly"
          type="number"
        ></q-input>
      </template>
      <template v-if="type === 'password'">
        <q-input
          :for="`password-input-${name}`"
          v-model="values[name]"
          :maxlength="maxLength"
          :readonly="readonly"
          :type="showPassword ? 'text' : 'password'"
          :rules="rules"
        >
          <template v-slot:append>
            <q-icon
              :id="`icon-hide-or-show-${name}`"
              :name="showPassword ? 'las la-eye-slash' : 'las la-eye'"
              :title="showPassword ? 'Esconder senha' : 'Mostrar senha'"
              color="darker-grey"
              style="cursor: pointer"
              @click="showPassword = !showPassword"
            ></q-icon>
          </template>
        </q-input>
      </template>
      <template v-if="type === 'radio'">
        <div class="row q-p-md q-col-gutter-md">
          <div
            v-for="(option, optionIndex) in options"
            :key="option.value"
            :class="option.fullWidth ? 'col-12' : 'col-12 col-sm-6'"
          >
            <div class="radio-option semi-rounded q-px-sm">
              <q-radio
                :id="`radio-option-${option.value}`"
                v-model="values[name]"
                :val="option?.value"
                :label="option?.label"
                :readonly="readonly"
                class="full-width"
                style="height: 48px"
              ></q-radio>
            </div>
          </div>
        </div>
      </template>

      <template v-if="type === 'checkbox'">
        <div class="field-checkbox row items-center">
          <q-checkbox
            :id="`checkbox-field-${name}`"
            v-model="values[name]"
            class="full-width"
            :false-value="falseValue"
            :true-value="trueValue"
            :readonly="readonly"
            :label="values[name] ? trueLabel : falseLabel"
          ></q-checkbox>
        </div>
      </template>

      <template v-if="type === 'toggle'">
        <div class="field-toggle">
          <q-toggle
            :id="`toggle-field-${name}`"
            v-model="values[name]"
            :false-value="falseValue"
            :true-value="trueValue"
            :readonly="readonly"
          ></q-toggle>
        </div>
      </template>
      <template v-if="type === 'textarea'">
        <div>
          <q-input
            autogrow
            :for="`textarea-input-${name}`"
            v-model="values[name]"
            :false-value="falseValue"
            :true-value="trueValue"
            :readonly="readonly"
            :label="values[name] ? trueLabel : falseLabel"
            type="textarea"
          />
        </div>
      </template>
      <template v-if="type === 'file'">
        <div>
          <q-input
            v-model="values[name]"
            :false-value="falseValue"
            :true-value="trueValue"
            :readonly="readonly"
            :label="values[name] ? trueLabel : falseLabel"
            type="file"
          />
        </div>
      </template>
    </template>
  </div>
</template>
<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  fieldDef: {
    default: () => {
      return {};
    },
    required: true,
    type: Object,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
  primaryKey: {
    type: String,
  },
  values: {
    default: () => {
      return {};
    },
    required: true,
    type: Object,
  },
});

const showPassword = ref(false);

const rules = computed(() => props.fieldDef.rules ?? []);
const falseLabel = computed(() => props.fieldDef?.falseLabel ?? "");
const falseValue = computed(() => props.fieldDef?.falseValue ?? false);
const label = computed(() => props.fieldDef?.label ?? "");
const maxLength = computed(() => props.fieldDef?.maxLength ?? 50);
const options = computed(() => props.fieldDef?.options ?? []);
const name = computed(() => props.fieldDef?.name ?? "");
const readonly = computed(
  () => props.isEditing && props.fieldDef?.name === props.primaryKey
);
const trueLabel = computed(() => props.fieldDef?.trueLabel ?? "");
const trueValue = computed(() => props.fieldDef?.trueValue ?? true);
const type = computed(() => props.fieldDef?.type ?? "");
</script>
